// extracted by mini-css-extract-plugin
module.exports = {"speakerTerms":"styles_speakerTerms__3Hr6C","block":"styles_block__38u0E","pMargin":"styles_pMargin__2i32O"};